import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { LayoutDashboard, Columns, Users, Trophy, Megaphone, MessageCircle, Settings, LogOut } from 'lucide-react';
import { Avatar } from '../ui/Avatar';
export function Sidebar() {
  const location = useLocation();
  const navItems = [{
    path: '/',
    label: 'Dashboard',
    icon: LayoutDashboard
  }, {
    path: '/kanban',
    label: 'Kanban',
    icon: Columns
  }, {
    path: '/clientes',
    label: 'Clientes',
    icon: Users
  }, {
    path: '/ranking',
    label: 'Ranking',
    icon: Trophy,
    highlight: true
  }, {
    path: '/campanhas',
    label: 'Campanhas',
    icon: Megaphone
  }, {
    path: '/whatsapp',
    label: 'WhatsApp',
    icon: MessageCircle
  }];
  return <aside className="hidden md:flex flex-col w-64 h-screen bg-background-lighter border-r border-white/5 fixed left-0 top-0 z-50" data-id="element-94">
      {/* Logo */}
      <div className="p-6" data-id="element-95">
        <h1 className="text-2xl font-bold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent" data-id="element-96">
          Rota's Makeup
        </h1>
        <p className="text-xs text-text-muted mt-1" data-id="element-97">Sales Management</p>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-3 space-y-1 overflow-y-auto" data-id="element-98">
        {navItems.map(item => {
        const isActive = location.pathname === item.path;
        const Icon = item.icon;
        return <Link key={item.path} to={item.path} className={`
                flex items-center px-3 py-3 rounded-lg text-sm font-medium transition-all duration-200 group
                ${isActive ? 'bg-primary/10 text-primary-light' : 'text-text-secondary hover:bg-white/5 hover:text-white'}
              `} data-id="element-99">
              <Icon className={`
                  mr-3 h-5 w-5 transition-colors
                  ${isActive ? 'text-primary' : 'text-text-muted group-hover:text-white'}
                  ${item.highlight ? 'text-accent' : ''}
                `} data-id="element-100" />
              {item.label}
            </Link>;
      })}
      </nav>

      {/* Bottom Actions */}
      <div className="p-4 border-t border-white/5 space-y-2" data-id="element-101">
        <Link to="/configuracoes" className={`
            flex items-center px-3 py-2 rounded-lg text-sm font-medium transition-colors
            ${location.pathname.includes('/configuracoes') ? 'bg-primary/10 text-primary-light' : 'text-text-secondary hover:bg-white/5 hover:text-white'}
          `} data-id="element-102">
          <Settings className="mr-3 h-5 w-5" data-id="element-103" />
          Configurações
        </Link>

        <div className="flex items-center p-3 mt-4 rounded-xl bg-white/5 hover:bg-white/10 transition-colors cursor-pointer" data-id="element-104">
          <Avatar fallback="AS" src="https://i.pravatar.cc/150?u=1" size="sm" status="online" data-id="element-105" />
          <div className="ml-3 flex-1 overflow-hidden" data-id="element-106">
            <p className="text-sm font-medium text-white truncate" data-id="element-107">Ana Silva</p>
            <p className="text-xs text-text-muted truncate" data-id="element-108">Vendedora</p>
          </div>
          <LogOut className="h-4 w-4 text-text-muted hover:text-white transition-colors" data-id="element-109" />
        </div>
      </div>
    </aside>;
}